import { createSharedPathnamesNavigation } from 'next-intl/navigation';
import { I18nConfig } from './config';

if (!I18nConfig.locales || I18nConfig.locales.length === 0) {
  throw new Error('I18nConfig.locales must be defined and contain at least one locale.');
}

export const { usePathname, useRouter } = createSharedPathnamesNavigation({
  locales: I18nConfig.locales,
  localePrefix: I18nConfig.localePrefix,
});
